const photographyLocations = {
    locations: [
        {
            name: 'Dwayne Watkins',
            code: 'dWatkins',
            country: 'Jamaica',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/dWatkins-collage.jpg',

        },
        {
            name: 'Suki MacDonald Kapahi',
            code: 'suki',
            country: 'Jamaica',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/suki-collage.jpg',
        },
        {
            name: 'Tiffany Lue Yen',
            code: 'tYen',
            country: 'Jamaica',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/tYen-collage.jpg',
        },
        {
            name: 'Alan Smith',
            code: 'aSmith',
            country: 'Jamaica',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/aSmith-collage.jpg',
        },
        {
            name: 'Daniel Macrion',
            code: 'dMacrion',
            country: 'Saint Lucia',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/dMacrion-collage.jpg',
        },
        {
            name: 'Dante Carrer',
            code: 'dCarrer',
            country: 'Bahamas',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/dCarrer-collage.jpg',
        },
        {
            name: 'Disha Fraser',
            code: 'dFraser',
            country: 'Bahamas',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/dFraser-collage.jpg',
        },
        {
            name: 'Joseph &amp; Janet Jones',
            code: 'jJones',
            country: 'Antigua',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/jJones-collage.jpg',
        },
        {
            name: 'Jason Pickering',
            code: 'jPickering',
            country: 'Antigua',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/jPickering-collage.jpg',
        },
        {
            name: 'Marc Hubbard',
            code: 'mHubbard',
            country: 'Antigua',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/mHubbard-collage.jpg',
        },
        {
            name: 'David Twum&dash;Barimah',
            code: 'dBarimah',
            country: 'Grenada',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/dBarimah-collage.jpg',
        },
        {
            name: 'Dwain Thomas',
            code: 'dThomas',
            country: 'Grenada',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/dThomas-collage.jpg',
        },
        {
            name: 'Steven Cumberbatch',
            code: 'sCumberbatch',
            country: 'Barbados',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/sCumberbatch-collage.jpg',
        },
        {
            name: 'Gina Francesca',
            code: 'gFrancesca',
            country: 'Barbados',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/gFrancesca-collage.jpg',
        },
        {
            name: 'Leslie St. John',
            code: 'lStJohn',
            country: 'Barbados',
            img: 'https://cdn.sandals.com/sandals/v12/images/weddings/weddings-local-photographers/lStJohn-collage.jpg',
        },

    ]
};

module.exports = photographyLocations;
